exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3deU02xE2IOj-sXBeSyzGn {\n\n}\n", ""]);

// exports
exports.locals = {
	"patientReport": "_3deU02xE2IOj-sXBeSyzGn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/pages/PatientReport/PatientReport.css
// module id = 9313
// module chunks = 23